"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _InstructionsListModule = _interopRequireDefault(require("../../scss/InstructionsList.module.scss"));
function InstructionsList(_ref) {
  let {
    headerHtml = '',
    instructions = []
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: [_InstructionsListModule.default['instructions-list'], 'instructions-list'].join(' ')
  }, headerHtml !== '' && /*#__PURE__*/_react.default.createElement("h3", {
    className: [_InstructionsListModule.default['instructions-list__header'], 'instructions-list__header'].join(' ')
  }, (0, _htmlReactParser.default)(headerHtml)), /*#__PURE__*/_react.default.createElement("ol", {
    className: [_InstructionsListModule.default['instructions-list__list'], 'instructions-list__list'].join(' ')
  }, instructions.map(item => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: [_InstructionsListModule.default['instructions-list__item'], 'instructions-list__item'].join(' '),
      key: "".concat(Math.random() * 1000000)
    }, (0, _htmlReactParser.default)(item));
  })));
}
var _default = exports.default = InstructionsList;